import type React from 'react';

import { EventApiProvider } from '@vlabs/monokit/entities/events/api';
import { DEFAULT_EVENT_LIST_PERMISSIONS } from '@vlabs/monokit/entities/events/event-list-table';
import {
  EventListFastFilters,
  EventListFilterMenu,
} from '@vlabs/monokit/entities/events/filters';

import { EventListPageView } from './EventListPageView';
import { EventListViewer } from './EventListViewer';

interface EventListPageProps {
  includedAttributes?: string[];
}

function EventListPage({
  includedAttributes = [],
}: EventListPageProps): React.JSX.Element {
  return (
    <EventApiProvider>
      <EventListPageView
        fastFilters={EventListFastFilters}
        filterMenu={EventListFilterMenu}
        includedAttributes={includedAttributes}
        permissions={DEFAULT_EVENT_LIST_PERMISSIONS}
        viewer={EventListViewer}
      />
    </EventApiProvider>
  );
}

export { EventListPage };
